import type { BoxTextWrap } from './custom-template';

/**
 * `value` has the shape of an InDesign Text Wrap (`CustomTemplateBoxBase.textWrap`). The first editor stored a boolean
 * `textWrap` of its own on a drawable: that is no wrap, and it must not reach a box.
 */
export function isBoxTextWrap(value: unknown): value is BoxTextWrap {
  return typeof value === 'object' && value !== null && Array.isArray((value as { offsets?: unknown }).offsets);
}

/**
 * `wrap` of a box scaled by `xScale`×`yScale`: its offsets are canvas px (top, left, bottom, right), the contour is
 * normalized to the box and stays. A contour keeps one distance all round (`offsets[0]`, the engine applies it on both
 * axes), so a wrap that follows its contour scales every offset by the geometric mean of the two scales; without a
 * usable contour (fewer than 3 points) it wraps the rectangle, offsets per axis.
 */
export function scaleTextWrap(wrap: BoxTextWrap, xScale: number, yScale: number): BoxTextWrap {
  const [top, left, bottom, right] = wrap.offsets;
  if (wrap.mode === 'contour' && wrap.contour && wrap.contour.length >= 3) {
    const s = Math.sqrt(Math.abs(xScale * yScale));
    return { ...wrap, offsets: [top * s, left * s, bottom * s, right * s] };
  }

  return { ...wrap, offsets: [top * yScale, left * xScale, bottom * yScale, right * xScale] };
}
